import React from 'react';
import logo from '../../assets/logo.svg';

export default function ClockEarningsLogo({ height, style = {}, className = '' }) {
  const heightStyle = height !== undefined ? { height } : {};
  return (
    <img
      src={logo}
      alt="Clock Earnings"
      className={className}
      style={{ width: 'auto', display: 'block', objectFit: 'contain', ...heightStyle, ...style }}
    />
  );
}
